import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { RoomGeometry } from '@/shared/model';
import { roundTo } from '@/shared/lib/number';

interface RoomStatsProps {
  geometry: RoomGeometry;
}

export const RoomStats: FC<RoomStatsProps> = ({ geometry }) => {
  const { t } = useTranslation();
  
  return (
    <div className="mt-6">
        <div className="flex flex-wrap gap-3 p-4 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800">
            {[
                {
                    key: 'floorArea',
                    label: t('room_input.stats.floor_ceiling', 'Пол / Потолок'),
                    value: geometry.floorArea,
                    unit: t('common.unit_m2', 'м²'),
                },
                { key: 'wallArea', label: t('room_input.stats.walls_total', 'Стены (Итог)'), value: geometry.wallArea, unit: t('common.unit_m2', 'м²') },
                { key: 'perimeter', label: t('room_input.stats.perimeter', 'Периметр'), value: geometry.perimeter, unit: t('common.unit_lm', 'мп') },
                {
                    key: 'slopes',
                    label: t('room_input.stats.slopes', 'Откосы'),
                    value: roundTo(geometry.windowSlopes + geometry.doorSlopes + (geometry.partitionsEndsLinear || 0), 2),
                    unit: t('common.unit_lm', 'мп'),
                    color: 'text-green-700 dark:text-green-400',
                    bg: 'bg-green-100/50 dark:bg-green-900/20'
                },
            ].map((stat, i) => (
                <motion.div
                    key={i}
                    whileHover={{ y: -2 }}
                    className={`flex-1 min-w-[110px] sm:min-w-[130px] text-center ${stat.bg || 'bg-white dark:bg-slate-900'} p-3 rounded-xl shadow-sm border border-slate-100 dark:border-slate-800 transition-all`}
                >
                    <div className="text-[10px] text-slate-500 dark:text-slate-400 uppercase font-semibold mb-1.5 tracking-wider whitespace-nowrap">
                        {stat.label}
                    </div>
                    <div className={`text-lg font-bold font-mono tabular-nums ${stat.color || 'text-slate-800 dark:text-slate-100'} leading-none flex flex-col items-center gap-1`}>
                        <span data-testid={`room-stat-${stat.key}`}>{stat.value}</span>
                        <span className="text-[10px] font-semibold opacity-70 uppercase tracking-wider">{stat.unit}</span>
                    </div>
                </motion.div>
            ))}
        </div>
    </div>
  );
};
